import { rem, createStyles, getSize } from '@mantine/styles';
var THUMB_SIZES = {
  xs: rem(8),
  sm: rem(12),
  md: rem(16),
  lg: rem(20),
  xl: rem(22)
};
var useStyles = createStyles(function (theme, _params, _ref) {
  var size = _ref.size;

  var _size = getSize({
    size,
    sizes: THUMB_SIZES
  });

  return {
    thumb: {
      overflow: "hidden",
      boxSizing: "border-box",
      position: "absolute",
      boxShadow: "0 0 ".concat(rem(1), " rgba(0, 0, 0, .6)"),
      border: "".concat(rem(2), " solid ").concat(theme.white),
      backgroundColor: "transparent",
      width: _size,
      height: _size,
      borderRadius: _size
    }
  };
});
export default useStyles;
export { THUMB_SIZES };